export default "../img/timeline-current-line.svg";